module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiBAMAAADIaRbxAAAAKlBMVEUAAAAzukM4xFA4xFA1wk4xvEk4xFA4xFA4xFA4w1A2wU83w1A4xE85xFHdu02SAAAADXRSTlMADrR9IRfy7MygPWBZo3geTwAAAM9JREFUKM9jAAPWne13K2YHMMABl+5dELi0ACbAAhSACDlARY7dhYEciADzXQQwAIvYIolcBgnw3EUGB4AibhBDXSDGpwBFIKwrDL4QGaBbIKovMshCGAsYmNBEFBhi0USuMuxFE7nNMBdN5CZDL5rIDYZaNJHrDLloIncZ7qKJXIPpugpzxnWYyTcF58JMBjIgqqH0TagLEeA2TPvdjrswA5lggWcL8ykXml0LYCF2i2EtJMTgoXrdGOKwFMyQx4gdzBjEiGXMlIA1tWCmKAA1XWx5IyENkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/reminder.png
// module id = 106
// module chunks = 0